import axios from 'axios'

export const baseURL = 'https://sheets.googleapis.com/v4/spreadsheets'

//Id da Planilha
export const idService = '13B5QC6OVrV42ZdfOcDQvI1UO9axF9q6DUojSAh_2Y1Q'

//Api do Google API
export const apiKey = 'AIzaSyADEiPUWa8BtnV6feps58RxD3AZQ5q4CJM'

//Colunas
export const tabs1 = 'beberibe'
export const tabs2 = 'caninde'
export const tabs3 = 'caucaia - novo pabussu'
export const tabs4 = 'maranguape'
export const tabs5 = 'oros'
export const tabs6 = 'campos sales'
export const tabs7 = 'quiterianopolis'
export const tabs8 = 'quixeramobim'
export const tabs9 = 'Caucaia - JuremaAraturi'
export const tabs10 = 'brejo santo'
export const tabs11 = 'piquet carneiro'
export const tabs12 = 'boa viagem'
export const tabs13 = 'iguatu'
export const tabs14 = 'russas'
export const tabs15 = 'mauriti'
export const tabs16 = 'Lavras da Manguabeira'
export const tabs17 = 'crateus'
export const tabs18 = 'iguatu'
export const tabs19 = 'itapipoca'
export const tabs20 = 'madalena'
export const tabs21 = 'fortaleza'
export const tabs22 = 'jaguaribe'
export const tabs23 = 'maracanau'
export const tabs24 = 'sobral'


//Colunas
export const values = 'A5:AZ500'

export default class SheetsSevices {
    
    getFortaleza() {
        return axios.get(`${baseURL}/${idService}/values/${tabs21}!${values}?access_token=${apiKey}=&key=${apiKey}`).then(res => res.data)
    }
    getJaguaribe() {
        return axios.get(`${baseURL}/${idService}/values/${tabs22}!${values}?access_token=${apiKey}=&key=${apiKey}`).then(res => res.data)
    }
    getMaracanau() {
        return axios.get(`${baseURL}/${idService}/values/${tabs23}!${values}?access_token=${apiKey}=&key=${apiKey}`).then(res => res.data)
    }
    getQuixeramobim() {
        return axios.get(`${baseURL}/${idService}/values/${tabs8}!${values}?access_token=${apiKey}=&key=${apiKey}`).then(res => res.data)
    }
    getSobral() {
        return axios.get(`${baseURL}/${idService}/values/${tabs24}!${values}?access_token=${apiKey}=&key=${apiKey}`).then(res => res.data)
    }
    // getPadrao() {
    //     return axios.get(`${baseURL}/${idCienciasBiologicas}/values/`)
    // }
}
